import type React from 'react';

import { Control } from '@vlabs/uikit';
import { routes } from '@vlapps/point/src/app/routes';
import qs from 'qs';
import { useTranslation } from 'react-i18next';
import { generatePath, useHistory } from 'react-router-dom';

interface SearchFaceButtonProps {
  faceId: string;
  className?: string;
  disabled?: boolean;
}

function SearchFaceButton({
  faceId, className = undefined, disabled = false,
}: SearchFaceButtonProps): React.JSX.Element {
  const { t } = useTranslation();
  const history = useHistory();

  const handleClick = () => {
    history.push({
      pathname: generatePath(routes.search),
      search: qs.stringify({
        references: [{
          id: faceId,
          type: 'face',
          referenceType: 'face',
        }],
      }),
    });
  };

  return (
    <Control.Button
      className={className}
      data-testid="face card.buttons.face search button"
      disabled={disabled}
      kind="secondary"
      onClick={handleClick}
      size="small"
      variant="outlined"
    >
      {t('card-page:face card.buttons.face search button.label')}
    </Control.Button>
  );
}

export { SearchFaceButton };
